export const menuItemsId = {
  Prelobby: 1,
  Lobby: 2,
  Game: 3,
  LeaderBoard: 4,
  PhotoBooth: 5,
  MyProfile: 7,
  videoPlayList: 6,
};

export const menuItemsIndex = {
  Prelobby: 0,
  Lobby: 1,
  Game: 2,
  LeaderBoard: 3,
  PhotoBooth: 4,
  MyProfile: 6,
  videoPlayList: 5,
};

export const SubMenuId = {
  Chat: 1,
  QNA: 2,
  POll: 3,
  GoToStage: 4,
  Call: 5,
  Overlay: 6,
  iframe: 7,
};

export const NetworkingSubmenuId = {
  Chat: 1,
};

export const DBRSubMenuIndex = {
  Call: 0,
  QNA: 1,
  POll: 2,
  GoToStage: 3,
};

export const menuItems = [
  {
    id: menuItemsId.Prelobby,
    name: "PreLobby",
    class: "icon-pre-lobby-n",
  },
  {
    id: menuItemsId.Lobby,
    name: "Funzone",
    class: "icon-lobby",
  },
  {
    id: menuItemsId.Game,
    name: "Treasure hunt",
    class: "icon-game",
  },
  {
    id: menuItemsId.LeaderBoard,
    name: "Leader Board",
    class: "icon-board",
  },
  {
    id: menuItemsId.PhotoBooth,
    name: "Photobooth",
    class: "icon-photo",
  },
  {
    id: menuItemsId.videoPlayList,
    name: "SEPHORA'S GOT TALENT",
    class: "icon-play",
    liClass: 'invered-color'
  },
  {
    id: menuItemsId.MyProfile,
    name: "Profile",
    class: "icon-profile",
  },
];
